import React, { useState, useEffect, useRef } from 'react';
import styles from './WelcomeHeader.module.scss';
import { ReactComponent as Logo } from '../../assets/icons/fa.svg';
import Login from '../Login/Login';

const navItems = [
  { id: 'features', label: 'Возможности' },
  { id: 'how-it-works', label: 'Как это работает' },
  { id: 'faq', label: 'Вопросы' },
];

const WelcomeHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const [indicatorStyle, setIndicatorStyle] = useState({ width: 0, left: 0, opacity: 0 });

  const navRefs = useRef({});

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 50;
      setIsScrolled(scrolled);

      if (!scrolled) {
        setActiveSection('');
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && window.scrollY > 50) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { rootMargin: '-40% 0px -60% 0px' }
    );

    navItems.forEach(({ id }) => {
      const element = document.getElementById(id);
      if (element) observer.observe(element);
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (activeSection && navRefs.current[activeSection]) {
      const el = navRefs.current[activeSection];
      setIndicatorStyle({
        width: el.offsetWidth,
        left: el.offsetLeft,
        opacity: 1,
      });
    } else {
      setIndicatorStyle((prev) => ({
        ...prev,
        width: 0,
        opacity: 0,
      }));
    }
  }, [activeSection]);

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}>
      <div className={styles.header__container}>
        <div className={styles.logo__container}>
          <Logo className={styles.logo} />
        </div>

        <nav className={styles.nav}>
          <ul className={styles.nav__list}>
            {navItems.map(({ id, label }) => (
              <li
                key={id}
                className={styles.nav__item}
                ref={(el) => (navRefs.current[id] = el)}
              >
                <a
                  href={`#${id}`}
                  className={`${styles.nav__link} ${activeSection === id ? styles['nav__link--active'] : ''
                    }`}
                >
                  {label}
                </a>
              </li>
            ))}
            <div
              className={styles.nav__indicator}
              style={{
                width: `${indicatorStyle.width}px`,
                transform: `translateX(${indicatorStyle.left}px)`,
                opacity: indicatorStyle.opacity,
              }}
            />
          </ul>
        </nav>

        <div className={styles.actions}>
          <Login trigger='Войти' triggerClassName={styles.loginBtn} />
        </div>
      </div>
    </header>
  );
};

export default WelcomeHeader;